<nz-card nzTitle="Units of Measure for Material">
  <nz-skeleton [nzActive]="true" [nzLoading]="(isLoading$ | async) ?? false">
    <ng-container *ngIf="uom$ | async as data; else noUom">
      <nz-table #uomTable [nzData]="data" nzSize="small" nzShowPagination="false">
        <thead>
          <tr>
            <th>Length</th>
            <th>Height</th>
            <th>Width</th>
            <th>Weight (1 piece)</th>
            <th>Volume</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let uom of uomTable.data; trackBy: trackByRef">
            <td>{{ uom.length }} {{ uom.unitOfDimension | lowercase }}</td>
            <td>{{ uom.height }} {{ uom.unitOfDimension | lowercase }}</td>
            <td>{{ uom.width }} {{ uom.unitOfDimension | lowercase }}</td>
            <td>{{ uom.grossWeight }} {{ uom.weightUnit | lowercase }}</td>
            <td>{{ uom.volume }} {{ uom.volumeUnit | lowercase }}</td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>
  </nz-skeleton>
</nz-card>

<ng-template #noUom>
  <nz-empty nzNotFoundContent="There are no units of measure for this design"></nz-empty>
</ng-template>
